export const MAX_EXECUTIONS = [
  { label: '1 time', value: '1' },
  { label: '5 times', value: '5' },
  { label: '10 times', value: '10' },
  { label: '15 times', value: '15' },
  { label: '30 times', value: '30' },
  { label: '60 times', value: '60' },
  { label: '90 times', value: '90' },
]

export enum TRIGGER_DELAY_LABELS {
  MINUTE = 'minutes',
  HOUR = 'hours',
  DAY = 'days',
  WEEK = 'weeks',
  MONTH = 'months',
}

export enum FREQUENCY_LABELS {
  ONCE = 'One time',
  MINUTE = 'Every minute',
  HOURLY = 'Every hour',
  DAILY = 'Every day',
  WEEKLY = 'Every week',
  MONTHLY = 'Every month',
  QUARTERLY = 'Every 3 months',
  BIANNUALLY = 'Every 6 months',
  YEARLY = 'Every year',
}

import { StepStatus, StepType } from 'src/graphql/types/steps'
import { formatSnakeValue, formatStepType } from 'src/lib/formatters'

export const STEP_CONDITION_KEY = 'step'

/**
 * Display label for a tag condition from its resolved `tag` (the API resolves
 * archived tags too, and returns null once a tag is gone).
 */
export const formatTagConditionLabel = (
  tag: { label?: string | null; status?: string | null } | null | undefined
): string => {
  if (!tag?.label) return 'Deleted tag'
  return tag.status === 'ARCHIVED' ? `${tag.label} (archived)` : tag.label
}

export const CONDITIONS_KEYS = [
  {
    label: 'Applicant Stage',
    value: 'applicantStage',
  },
  { label: 'Hiring Stage', value: 'hiringStage' },
  { label: 'Call Count', value: 'callCount' },
  { label: 'Not Interested Reason', value: 'notInterestedReason' },
  { label: 'Disqualified Reason', value: 'disqualifiedReason' },
  { label: 'Terminated Reason', value: 'terminatedReason' },
  { label: 'Missed Outbound Call Count', value: 'missedOutboundCallCount' },
  { label: 'Job Listing', value: 'jobListingId' },
  { label: 'Job Listing Type', value: 'jobListingType' },
  { label: 'Tracking link type', value: 'linkType' },
  { label: 'Tags', value: 'tagId' },
  { label: 'Step', value: STEP_CONDITION_KEY },
]

export const STEP_TYPE_OPTIONS = Object.values(StepType).map((value) => ({
  label: formatStepType(value),
  value,
}))

export const STEP_STATUS_OPTIONS = Object.values(StepStatus).map((value) => ({
  label: formatSnakeValue(value),
  value,
}))

export const ACTIONS_KEYS = [
  {
    label: 'Send SMS',
    value: 'SMS',
  },
  { label: 'Send email', value: 'SEND_EMAIL' },
  { label: 'Send documents for signing', value: 'DOCUMENT_TEMPLATE_PACKAGE' },
  { label: 'Request an order', value: 'GENERATE_ORDER' },
  { label: 'Assign a lesson', value: 'ASSIGN_TRAINING' },
  { label: 'Assign a course', value: 'ASSIGN_COURSE' },
  { label: 'Send voice agent call', value: 'SEND_VOICE_AGENT_CALL' },
  { label: 'Change applicant status', value: 'CHANGE_APPLICANT_STATUS' },
  { label: 'Create task', value: 'CREATE_TASK' },
  { label: 'Add note', value: 'ADD_NOTE' },
  { label: 'Reassign lead employee', value: 'REASSIGN_LEAD_EMPLOYEE' },
  { label: 'Add member employee', value: 'ADD_MEMBER_EMPLOYEE' },
]
